import { PercentSeries } from '@amcharts/amcharts4/.internal/charts/series/PercentSeries';
import { Axis, AxisLabel, AxisLine, Chart, Grid } from '@amcharts/amcharts4/charts';
import { BaseObject, color, ColorSet, Container, ITheme, Scrollbar, Sprite, ZoomOutButton } from '@amcharts/amcharts4/core';
import amcharts from '@amcharts/amcharts4/themes/amcharts';
import amchartsdark from '@amcharts/amcharts4/themes/amchartsdark';
import dark from '@amcharts/amcharts4/themes/dark';
import dataviz from '@amcharts/amcharts4/themes/dataviz';
import frozen from '@amcharts/amcharts4/themes/frozen';
import kelly from '@amcharts/amcharts4/themes/kelly';
import material from '@amcharts/amcharts4/themes/material';
import microchart from '@amcharts/amcharts4/themes/microchart';
import moonrisekingdom from '@amcharts/amcharts4/themes/moonrisekingdom';
import spiritedaway from '@amcharts/amcharts4/themes/spiritedaway';

function dynamik(target: BaseObject): void {
  if (target instanceof ColorSet) {
    target.list = [
      color('#305785'),
      color('#915691'),
      color('#77B28C'),
      color('#A297F3'),
      color('#F48489'),
      color('#EA9662'),
      color('#EBD2B3')
    ];
  }
}

function odin(target: BaseObject): void {
  if (target instanceof ColorSet) {
    target.list = [
      color('#79ADB9'),
      color('#6D908B'),
      color('#4F6751'),
      color('#B17B6B'),
      color('#C0B57D'),
      color('#AEA493'),
      color('#9FA0A4'),
      color('#ADD7DD'),
      color('#A7C6C1'),
      color('#9DBA9E')
    ];
  }
}

function ignite(object: BaseObject): void {
  if (object instanceof ColorSet) {
    object.list = [
      color('#305785'),
      color('#915691'),
      color('#77B28C'),
      color('#A297F3'),
      color('#F48489'),
      color('#EA9662'),
      color('#EBD2B3')
    ];
  }
  if (object instanceof Sprite) {
    object.showSystemTooltip = false;
  }
  if (object instanceof Chart) {
    object.interactionsEnabled = false;
  }
  if (object instanceof Scrollbar) {
    object.startGrip.disabled = true;
    object.endGrip.disabled = true;
  }
  if (object instanceof AxisLabel || object instanceof AxisLine || object instanceof Grid) {
    object.disabled = true;
  }
  if (object instanceof Axis) {
    object.cursorTooltipEnabled = false;
  }
  if (object instanceof PercentSeries) {
    object.labels.template.disabled = true;
    object.ticks.template.disabled = true;
  }
  if (object instanceof ZoomOutButton) {
    object.padding(1, 1, 1, 1);
  }
  if (object instanceof Container) {
    if (object.minHeight) {
      object.minHeight = undefined;
    }
    if (object.minWidth) {
      object.minWidth = undefined;
    }
  }

}

function igniteWithLabels(object: BaseObject): void {
  if (object instanceof ColorSet) {
    object.list = [
      color('#305785'),
      color('#915691'),
      color('#77B28C'),
      color('#A297F3'),
      color('#F48489'),
      color('#EA9662'),
      color('#EBD2B3')
    ];
  }
  if (object instanceof Sprite) {
    object.showSystemTooltip = false;
  }
  if (object instanceof Chart) {
    object.interactionsEnabled = false;
  }
  if (object instanceof Scrollbar) {
    object.startGrip.disabled = true;
    object.endGrip.disabled = true;
  }
  if (object instanceof AxisLine || object instanceof Grid) {
    object.disabled = true;
  }
  if (object instanceof Axis) {
    object.cursorTooltipEnabled = false;
  }
  if (object instanceof PercentSeries) {
    object.labels.template.disabled = true;
    object.ticks.template.disabled = true;
  }
  if (object instanceof ZoomOutButton) {
    object.padding(1, 1, 1, 1);
  }
  if (object instanceof Container) {
    if (object.minHeight) {
      object.minHeight = undefined;
    }
    if (object.minWidth) {
      object.minWidth = undefined;
    }
  }

}

export const chartThemes: { name: string; theme: ITheme }[] = [
  { name: 'Dynamik', theme: dynamik },
  { name: 'Odin', theme: odin },
  { name: 'Ignite', theme: ignite },
  { name: 'Ignite with labels', theme: igniteWithLabels },
  { name: 'AmCharts', theme: amcharts },
  { name: 'AmCharts Dark', theme: amchartsdark },
  { name: 'Dark', theme: dark },
  { name: 'Dataviz', theme: dataviz },
  { name: 'Frozen', theme: frozen },
  { name: 'Kelly', theme: kelly },
  { name: 'Material', theme: material },
  { name: 'Micro Chart', theme: microchart },
  { name: 'Moonrise Kingdom', theme: moonrisekingdom },
  { name: 'Spirited Away', theme: spiritedaway }
];
